import Joi from 'joi'

export const schema = Joi.object({
  password: Joi.string().required().messages({
    'string.empty': 'É necessário informar uma nova senha.',
  }),
  confirmation: Joi.string().required().valid(Joi.ref('password')).messages({
    'string.empty': 'É necessário informar uma nova senha.',
  }),
})
